import { GradingMonitoring } from "../entities/grading-monitoring.entity";
import { GradingMonitoringDTO } from "./grading-monitoring.dto";

export class GradeMonitoringAdapter {
    public convertDtoToEntity(dto: GradingMonitoringDTO,isUpdate: boolean = false):GradingMonitoring{
        const entity = new GradingMonitoring;
        entity.gradingMonitoringId = dto.gradingMonitoringId
        entity.gradingInventoryId = dto.gradingInventoryId
        entity.typeOfProduct = dto.typeOfProduct
        entity.headlessCount = dto.headlessCount
        entity.qualityEval = dto.qualityEval
        entity.icing = dto.icing
        entity.tempOfProduct = dto.tempOfProduct
        entity.chlorineLevel = dto.chlorineLevel
        entity.gradesObtaine = dto.gradesObtaine
        entity.observedCount = dto.observedCount
        entity.correctiveAction = dto.correctiveAction
        entity.signOfSupervisor = dto.signOfSupervisor
        entity.verificationByQC = dto.verificationByQC
        entity.correctiveAction = dto.correctiveAction
        if(dto.gradingMonitoringId){
            entity.gradingMonitoringId = dto.gradingMonitoringId;
            entity.updatedUser = dto.updatedUser;
        }else{
            entity.createdUser = dto.createdUser;
        }
        return entity;

        
}

        public convertEntityToDto(obj: GradingMonitoring) : GradingMonitoringDTO {
            const dto= new GradingMonitoringDTO;
        dto.gradingMonitoringId = obj.gradingMonitoringId;
        dto.gradingInventoryId = obj.gradingInventoryId;
        dto.typeOfProduct = obj.typeOfProduct;
        dto.qualityEval = obj.qualityEval;
        dto.icing = obj.icing;
        dto.tempOfProduct = obj.tempOfProduct;
        dto.chlorineLevel = obj.chlorineLevel;
        dto.gradesObtaine = obj.gradesObtaine;
        dto.observedCount = obj.observedCount;
        dto.correctiveAction = obj.correctiveAction;
        dto.signOfSupervisor = obj.signOfSupervisor;
        dto.verificationByQC = obj.verificationByQC;
        dto.correctiveAction = obj.correctiveAction
        dto.createdAt = obj.createdAt;
        dto.updatedAt = obj.updatedAt;
        dto.createdUser = obj.createdUser;
        dto.updatedUser = obj.updatedUser;
        dto.versionFlag = obj.versionFlag;
        return dto; 
        }

}